import { useT } from "../i18n/context";
import { HIDE_GIFTS_KEY, useStore } from "../store";
import { PrefSwitch } from "./PrefSwitch";

/** "Hide gifts at the table" for this device (review 0022 decision 154). */
export function HideGifts() {
  const { t } = useT();
  const hidden = useStore((s) => s.hideGifts);
  const set = useStore((s) => s.set);
  const toggle = (next: boolean) => {
    set({ hideGifts: next });
    try {
      localStorage.setItem(HIDE_GIFTS_KEY, next ? "1" : "0");
    } catch {
      // Without storage the choice lasts until the Activity closes.
    }
  };
  return (
    <PrefSwitch
      label={t("data.hideGifts")}
      about={t("data.hideGifts.about")}
      checked={hidden}
      onChange={toggle}
    />
  );
}
